import { Brand, createBranded } from '@deltasierra/type-utilities';

export type TemplateContentBuildRevisionId = Brand<number, 'TemplateContentBuildRevisionId'>;
export const TemplateContentBuildRevisionId = createBranded<TemplateContentBuildRevisionId>();
